enum CreateEditCustomFieldStep {
  BASIC_INFO,
  FIELD_SETUP,
  SHARE_SAVE,
}

export default CreateEditCustomFieldStep;
